import type { ShiftMealsList } from '@libs/data-access/queries'

import type { MealValue } from '../components/MealRow/MealRow'

/**
 * @deprecated think about what you are doing! a kitten will die if you use this!
 */
const getMealsLegacy = (
  mealDefault: boolean,
  defaultMealType?: string,
  shiftMeals?: ShiftMealsList,
  shiftId?: number
): { value: MealValue }[] => {
  // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
  if (shiftMeals?.size > 0) {
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    return shiftMeals
      .map(shiftMeal => ({
        value: {
          // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
          id: shiftMeal.get('id') || null,
          // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
          initialMeal: shiftMeal.get('planned_meal_type', null),
          checked: true,
          meal: {
            // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
            id: shiftMeal.get('id') || null,
            // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
            value: shiftMeal.get('planned_meal_type')
          }
        }
      }))
      .toArray()
  }

  // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
  return mealDefault && !shiftId
    ? [
        {
          value: {
            id: null,
            initialMeal: undefined,
            checked: true,
            meal: {
              id: null,
              value: defaultMealType
            }
          }
        }
      ]
    : []
}

export default getMealsLegacy
